export default "__VITE_ASSET__B5U8bNXD__"